export default __webpack_public_path__ + "static/media/M13.cf0e372a.jpg";